import { THEME } from 'reporting-ui-components/constants/themes';
export const isBrandKitTheme = theme => theme === THEME.BRAND_KIT;
export const getBrandKit = (theme, brandKitPalettes, brandKitId) => isBrandKitTheme(theme) && brandKitPalettes && brandKitId && brandKitPalettes.get(brandKitId);